import React, { useCallback, useState } from 'react';

export default function EmailLink({ className }) {
  const [label, setLabel] = useState('contact us');

  const reveal = useCallback((event) => {
    const user = ['typeclick', 'tests'].join('');
    const domain = ['gmail', 'com'].join('.');
    const address = `${user}@${domain}`;
    event.currentTarget.href = `mailto:${address}`;
    setLabel(address);
  }, []);

  return (
    <a
      className={className}
      href="#contact"
      rel="nofollow"
      onFocus={reveal}
      onMouseOver={reveal}
      onClick={reveal}
    >
      {label}
    </a>
  );
}
